import React, { useState, useEffect } from 'react';
import { Card, Button, Alert, Typography, Space } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import ZohoConfigModal from './ZohoConfigModal';
import { getZohoConfig, saveZohoConfig } from '../../api/zoho-crm';

const { Title, Text } = Typography;

const ZohoSetup = () => {
  const [configModal, setConfigModal] = useState(false);
  const [hasConfig, setHasConfig] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const authState = useSelector((state) => state.authState.value);

  useEffect(() => {
    checkExistingConfig();
  }, []);

  const checkExistingConfig = async () => {
    try {
      const response = await getZohoConfig(authState?.token);
      setHasConfig(!!response.data);
      if (response.data && typeof response.data.isActive !== 'undefined') {
        setIsActive(!!response.data.isActive);
      }
    } catch (error) {
      setHasConfig(false);
    } finally {
      setLoading(false);
    }
  };

  const setupInitialConfig = async () => {
    try {
      // Use your actual credentials
      const config = {
        clientId: "1000.Z3QJ3W8W1WBZ305WRVJJZMLQRHYJYO",
        clientSecret: "b241d30b3de6a0f987b93ad5774f32dc4b9fe490fe",
        refreshToken: "1000.7895c84bf5a232944e6d60404511f553.d0b1d26d5d2c3112a6f74fb6ce0a0e6e",
        apiDomain: "https://www.zohoapis.com"
      };

      await saveZohoConfig(config, authState?.token);
      setHasConfig(true);
    } catch (error) {
      console.error('Failed to setup Zoho config:', error);
    }
  };

  async function toggleActive(next) {
    try {
      setIsActive(next);
      await saveZohoConfig({ isActive: next ? 1 : 0 }, authState?.token);
    } catch (e) {
      setIsActive(!next);
    }
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ padding: 24 }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <SettingOutlined /> Zoho CRM Integration
            </Title>
            <Text type="secondary">
              Configure Zoho CRM to automatically sync leads with your KPIs
            </Text>
          </div>

          {hasConfig ? (
            <Alert
              message={`Zoho CRM is ${isActive ? 'enabled' : 'disabled'}`}
              description="Manage configuration using the button below."
              type={isActive ? 'success' : 'warning'}
              showIcon
            />
          ) : (
            <Alert
              message="Zoho CRM not configured"
              description="Set up your Zoho CRM credentials to enable automatic lead synchronization."
              type="warning"
              showIcon
            />
          )}

          <Space>
            <Button 
              type="primary" 
              onClick={() => setConfigModal(true)}
            >
              {hasConfig ? 'Update Configuration' : 'Configure Zoho CRM'}
            </Button>
            {!hasConfig && (
              <Button 
                onClick={setupInitialConfig}
              >
                Quick Setup (Use Default Credentials)
              </Button>
            )}
          </Space>
        </Space>
      </Card>

      <ZohoConfigModal
        visible={configModal}
        onClose={() => {
          setConfigModal(false);
          checkExistingConfig();
        }}
        token={authState?.token}
      />
    </div>
  );
};

export default ZohoSetup;